import { useState, useEffect } from 'react';

export default function useDevice() {
	const [windowSize, setWindowSize] = useState({
		isMobile: undefined,
		isTablet: undefined,
		isDesktop: undefined,
		widthWindow: undefined,
		heightWindow: undefined,
	});
	function handleResize() {
		const width = window.innerWidth;
		const height = window.innerHeight;
		setWindowSize({
			isMobile: width < 768,
			isTablet: width >= 768 && width < 1280,
			isDesktop: width >= 1280,
			widthWindow: width,
			heightWindow: height,
		});
	}
	useEffect(() => {
		window.addEventListener('resize', handleResize);
		handleResize();
		return () => window.removeEventListener('resize', handleResize);
	}, []);
	return windowSize;
}
